import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

import SearchFormWithNavigation from 'src/components/SearchForm/SearchFormWithNavigation';
import useTranslation from 'src/translations/useTranslation';

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();

  return {
    emoji: {
      fontSize: spacing(12),
      [breakpoint.up('md')]: {
        fontSize: spacing(18),
      },
    },
    text: {
      textAlign: 'center',
      marginTop: spacing(2),
      '& a': {
        textDecoration: 'none',
      },
    },
  } as const;
};

const Unavailable: FunctionComponent = () => {
  const classes = useStyles();
  const t = useTranslation();

  return (
    <Flex height="100%" flexDirection="column" justifyContent="center" alignItems="center">
      <Flex
        flex="1 0 auto"
        margin={[4, 0, 2]}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <span css={classes.emoji}>🙈</span>
        <Text<'h1'> css={classes.text} as="h1" variant="headline2">
          {t('dont_exist_anymore')}
        </Text>
        <Text<'h2'> css={classes.text} as="h2" variant="paragraph">
          {t('search_more_on_')}
        </Text>
      </Flex>
      <SearchFormWithNavigation
        data-testid="search-form-with-navigation"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        margin={0}
        width="100%"
      />
    </Flex>
  );
};

export default Unavailable;
